import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=e1cfe970&"
import script from "./CookieBar.vue?vue&type=script&lang=js&"
export * from "./CookieBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/benutzer/Desktop/401/Phywe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1cfe970')) {
      api.createRecord('e1cfe970', component.options)
    } else {
      api.reload('e1cfe970', component.options)
    }
    module.hot.accept("./CookieBar.vue?vue&type=template&id=e1cfe970&", function () {
      api.rerender('e1cfe970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/phywe/CookieBar.vue"
export default component.exports